import { createSlice } from '@reduxjs/toolkit'

import { ICurrencyReducers, ICurrencyState } from './currency.slice.types'

const initialState: ICurrencyState = {
  isLoading: false,
  error: null,
  selectedCurrency: null,
  currencyRates: null,
}

export const currencySlice = createSlice<ICurrencyState, ICurrencyReducers, string>({
  name: 'currency',
  initialState,
  reducers: {
    checkCurrencyRatesRequest: (state) => {
      state.isLoading = true
    },
    checkCurrencyRatesSuccess: (state, action) => {
      state.currencyRates = action.payload
      state.isLoading = false
    },
    checkCurrencyRatesFailure: (state) => {
      state.isLoading = false
    },
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload
    },
  },
})

export const CurrencyActions = currencySlice.actions
export const currencyReducer = currencySlice.reducer
